import React, { useState, useEffect, useMemo } from 'react';

const motifPatterns = [
  // 1. Selçuklu Yıldızı (8 Köşeli - Altın/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 0 L65 35 L100 50 L65 65 L50 100 L35 65 L0 50 L35 35 Z" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2"/><rect x="35" y="35" width="30" height="30" transform="rotate(45 50 50)" fill="none" stroke="rgba(241, 196, 15, 0.8)" stroke-width="2"/></svg>')`,
  
  // 2. Geometrik Rozet (Turkuaz/Altın)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.4)" stroke-width="1"/><path d="M50 10 L50 90 M10 50 L90 50 M22 22 L78 78 M22 78 L78 22" stroke="rgba(26, 188, 156, 0.8)" stroke-width="1"/><rect x="30" y="30" width="40" height="40" transform="rotate(45 50 50)" fill="none" stroke="rgba(241, 196, 15, 0.8)" stroke-width="2"/></svg>')`,
  
  // 3. Kenetli Altıgenler (Beyaz/Yeşil)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25 5 L75 5 L100 50 L75 95 L25 95 L0 50 Z" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2"/><path d="M25 5 L50 50 L75 5 M75 95 L50 50 L25 95 M0 50 L50 50 L100 50" stroke="rgba(46, 204, 113, 0.6)" stroke-width="1"/></svg>')`,
  
  // 4. Girih Geometrisi (Altın/Turuncu)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 5 L95 35 L80 90 L20 90 L5 35 Z" fill="none" stroke="rgba(241, 196, 15, 0.7)" stroke-width="2"/><path d="M50 5 L50 50 M95 35 L50 50 M80 90 L50 50 M20 90 L50 50 M5 35 L50 50" stroke="rgba(230, 126, 34, 0.6)" stroke-width="1"/><circle cx="50" cy="50" r="4" fill="rgba(255,255,255,0.8)"/></svg>')`,
  
  // 5. Kesişen Kareler (Mavi/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="20" width="60" height="60" fill="none" stroke="rgba(52, 152, 219, 0.7)" stroke-width="2"/><rect x="20" y="20" width="60" height="60" transform="rotate(45 50 50)" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2"/></svg>')`,

  // 6. Geometrik Lale (Kırmızı/Yeşil/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 90 L50 60 M50 60 Q20 60 20 30 Q20 10 50 20 Q80 10 80 30 Q80 60 50 60" fill="none" stroke="rgba(231, 76, 60, 0.8)" stroke-width="2"/><path d="M50 60 L30 80 M50 60 L70 80" stroke="rgba(46, 204, 113, 0.8)" stroke-width="2"/></svg>')`,

  // 7. Kilim Baklavası (Toprak/Altın)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 10 L90 50 L50 90 L10 50 Z" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2"/><path d="M50 25 L75 50 L50 75 L25 50 Z" fill="none" stroke="rgba(230, 126, 34, 0.7)" stroke-width="2"/><circle cx="50" cy="50" r="4" fill="rgba(241, 196, 15, 0.8)"/></svg>')`,

  // 8. Çintemani Geometrik (Beyaz/Mavi)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="35" cy="35" r="10" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2"/><circle cx="65" cy="35" r="10" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2"/><circle cx="50" cy="65" r="10" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2"/><path d="M20 85 Q50 95 80 85" stroke="rgba(52, 152, 219, 0.6)" stroke-width="2" fill="none"/><path d="M20 90 Q50 100 80 90" stroke="rgba(52, 152, 219, 0.6)" stroke-width="2" fill="none"/></svg>')`,

  // 9. 12 Köşeli Yıldız (Mor/Altın)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 0 L60 30 L90 20 L75 50 L90 80 L60 70 L50 100 L40 70 L10 80 L25 50 L10 20 L40 30 Z" fill="none" stroke="rgba(155, 89, 182, 0.6)" stroke-width="2"/><circle cx="50" cy="50" r="15" fill="none" stroke="rgba(241, 196, 15, 0.8)" stroke-width="2"/></svg>')`,

  // 10. Sonsuzluk Düğümü (Yeşil/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="80" height="80" fill="none" stroke="rgba(39, 174, 96, 0.7)" stroke-width="2"/><rect x="30" y="30" width="40" height="40" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2"/><path d="M10 50 L30 50 M70 50 L90 50 M50 10 L50 30 M50 70 L50 90" stroke="rgba(39, 174, 96, 0.7)" stroke-width="2"/></svg>')`,

  // 11. Selçuklu Yıldızı (10 Köşeli - Altın)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><polygon points="50,5 63,35 95,35 70,55 80,85 50,70 20,85 30,55 5,35 37,35" fill="none" stroke="rgba(241, 196, 15, 0.7)" stroke-width="2"/><circle cx="50" cy="50" r="5" fill="rgba(255,255,255,0.8)"/></svg>')`,

  // 12. Haliç İşi (Spiral - Mavi/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 50 m-40 0 a 40 40 0 1 0 80 0 a 40 40 0 1 0 -80 0" fill="none" stroke="rgba(52, 152, 219, 0.5)" stroke-width="1"/><path d="M50 50 m-25 0 a 25 25 0 1 0 50 0 a 25 25 0 1 0 -50 0" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2"/></svg>')`,

  // 13. Osmanlı Lalesi (Ters - Kırmızı)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 10 Q80 40 80 60 Q80 90 50 90 Q20 90 20 60 Q20 40 50 10" fill="none" stroke="rgba(231, 76, 60, 0.8)" stroke-width="2"/><path d="M50 10 L50 80" stroke="rgba(255,255,255,0.5)" stroke-width="1"/></svg>')`,

  // 14. Geometrik Örgü (Kufic - Turkuaz/Altın)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M10 10 H90 V90 H10 Z M20 20 V80 H80 V20 Z" fill="none" stroke="rgba(26, 188, 156, 0.7)" stroke-width="2"/><rect x="40" y="40" width="20" height="20" fill="rgba(241, 196, 15, 0.6)"/></svg>')`,

  // 15. Çarkıfelek (Beyaz/Altın)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 50 L50 5 L95 50 L50 95 L5 50 L50 5" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2"/><circle cx="50" cy="50" r="10" stroke="rgba(241, 196, 15, 0.8)" stroke-width="2" fill="none"/></svg>')`,

  // 16. Yıldız Geçişi (Mavi/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M0 50 L50 0 L100 50 L50 100 Z" fill="none" stroke="rgba(52, 152, 219, 0.6)" stroke-width="2"/><path d="M25 25 L75 75 M75 25 L25 75" stroke="rgba(255,255,255,0.4)" stroke-width="2"/></svg>')`,

  // 17. Rumi Kıvrım (Turuncu/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M20 80 C20 20 80 80 80 20" fill="none" stroke="rgba(230, 126, 34, 0.7)" stroke-width="3"/><circle cx="20" cy="80" r="3" fill="white"/><circle cx="80" cy="20" r="3" fill="white"/></svg>')`,

  // 18. Altıgen Petek (Altın/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25 10 L75 10 L100 50 L75 90 L25 90 L0 50 Z" fill="none" stroke="rgba(241, 196, 15, 0.5)" stroke-width="2"/><path d="M50 50 L25 10 M50 50 L75 10 M50 50 L100 50 M50 50 L75 90 M50 50 L25 90 M50 50 L0 50" stroke="rgba(255,255,255,0.3)" stroke-width="1"/></svg>')`,

  // 19. Karanfil (Kırmızı/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M50 90 L50 60 Q30 40 30 20 Q50 30 70 20 Q70 40 50 60" fill="none" stroke="rgba(231, 76, 60, 0.8)" stroke-width="2"/><circle cx="50" cy="15" r="5" fill="rgba(255,255,255,0.8)"/></svg>')`,

  // 20. Bulut (Mavi/Beyaz)
  `url('data:image/svg+xml;utf8,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M20 60 Q20 40 40 40 Q40 20 60 20 Q80 20 80 40 Q100 40 100 60" fill="none" stroke="rgba(52, 152, 219, 0.7)" stroke-width="2"/><path d="M20 60 Q40 80 60 60 Q80 80 100 60" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="2"/></svg>')`,
];

const PatternTile = ({ initialDelay, index }) => {
  const [currentBgIndex, setCurrentBgIndex] = useState(Math.floor(Math.random() * motifPatterns.length));
  const [nextBgIndex, setNextBgIndex] = useState(null);
  const [isFading, setIsFading] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Açılış animasyonu için delay
    const entryTimeout = setTimeout(() => {
      setIsVisible(true);
    }, initialDelay);

    // Rastgele bir bekleme süresi ata (2s ile 8s arası) + initialDelay
    const randomInterval = Math.random() * 8000 + 5000; 

    const timeout = setTimeout(() => {
      triggerTransition();
    }, initialDelay + randomInterval + 1000);

    return () => {
      clearTimeout(timeout);
      clearTimeout(entryTimeout);
    };
  }, [currentBgIndex]); // currentBgIndex değiştiğinde döngü yeniden başlar

  const triggerTransition = () => {
    // Mevcut olandan farklı rastgele bir desen seç
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * motifPatterns.length);
    } while (newIndex === currentBgIndex);

    setNextBgIndex(newIndex);
    setIsFading(true);

    // Geçiş animasyonu (CSS transition süresi kadar bekle - 2sn daha yumuşak)
    setTimeout(() => {
      setCurrentBgIndex(newIndex);
      setNextBgIndex(null);
      setIsFading(false);
    }, 2000);
  };

  return (
    <div 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ 
        position: 'relative', 
        width: '100%', 
        height: '100%', 
        overflow: 'hidden',
        opacity: isVisible ? (isHovered ? 1 : 0.25) : 0, // Varsayılan çok silik, hoverda net
        transform: isVisible ? (isHovered ? 'scale(1.15) rotate(5deg)' : 'scale(1) rotate(0deg)') : 'scale(0.8)',
        transition: 'opacity 1.5s ease, transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)', // Yaylanma efekti
        zIndex: isHovered ? 10 : 1,
        cursor: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><path d='M16 2 L20 6 L26 6 L26 12 L30 16 L26 20 L26 26 L20 26 L16 30 L12 26 L6 26 L6 20 L2 16 L6 12 L6 6 L12 6 Z' fill='%23f1c40f' stroke='%232c3e50' stroke-width='2'/><circle cx='16' cy='16' r='3' fill='%232c3e50'/></svg>") 16 16, pointer`,
      }}
    >
      {/* Aktif Arkaplan */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: motifPatterns[currentBgIndex],
          backgroundSize: '80%', // Biraz boşluk bırakarak daha zarif durmasını sağla
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          // Sürekli nefes alma efekti
          animation: isHovered ? 'none' : 'breathe 8s infinite ease-in-out alternate',
          zIndex: 1,
        }}
      />
      
      {/* Gelecek Arkaplan (Crossfade için üstte belirir) */}
      {nextBgIndex !== null && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: motifPatterns[nextBgIndex],
            backgroundSize: '80%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: isFading ? 1 : 0,
            transition: 'opacity 2s ease-in-out',
            zIndex: 2,
          }}
        />
      )}
    </div>
  );
};

const TurkishMosaicWall = () => {
  // Responsive grid hesabı
  const [gridSize, setGridSize] = useState({ cols: 16, rows: 9 });

  useEffect(() => {
    const updateGrid = () => {
      const width = window.innerWidth;
      if (width < 768) {
        // Mobile: 4 sütun, 10 satır (Daha büyük ve net motifler)
        setGridSize({ cols: 4, rows: 10 });
      } else if (width < 1024) {
        // Tablet: 8 sütun, 12 satır
        setGridSize({ cols: 8, rows: 12 });
      } else {
        // Desktop: 16 sütun, 9 satır (16:9 oranı)
        setGridSize({ cols: 16, rows: 9 });
      }
    };

    updateGrid();
    window.addEventListener('resize', updateGrid);
    return () => window.removeEventListener('resize', updateGrid);
  }, []);

  const { cols, rows } = gridSize;
  
  // useMemo ile array'i cache'le
  const tilesArray = useMemo(() => Array.from({ length: cols * rows }), [cols, rows]);

  return (
    <>
      <style>
        {`
          @keyframes breathe {
            0% { transform: scale(1); }
            100% { transform: scale(1.08); }
          }
        `}
      </style>
      <div
        style={{
          width: '100vw',
          height: '100vh',
          backgroundColor: 'transparent',
          display: 'grid',
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gridTemplateRows: `repeat(${rows}, 1fr)`,
          overflow: 'hidden',
        }}
      >
        {tilesArray.map((_, index) => (
          <PatternTile 
            key={index} 
            index={index}
            // Dalga efekti için index bazlı delay + rastgelelik
            initialDelay={(index * 30) + (Math.random() * 1000)} 
          />
        ))}
      </div>
    </>
  );
};

export default TurkishMosaicWall;